import React, { useState } from "react";
import PropTypes from "prop-types";

import ProductMeasurementList from "./ProductMeasurementList";
import ProductMeasurementModal from "./ProductMeasurementModal";
import IconInfoCircleGray from "../../component/icons/IconInfoCircleGray";
import "./ProductMeasurement.css";

const MEASUREMENT_DISCLAIMER = "측정 방법에 따라 ±1~3cm 오차가 있을 수 있어요.";

/**
 * 상품 상세 실측 섹션.
 * 인라인 요약(항목 + 값)은 SSR 로 렌더링하여 SEO 에 노출되고,
 * 'i' 아이콘 클릭 시 측정 방법 가이드 모달(PC: 중앙 / 모바일: 바텀시트)이 열립니다.
 *
 * @param {Array<{label: string, key?: string, value: number|null}>} measurements
 * @param {boolean} isMeasurable - 서브카테고리에 측정 항목이 존재하는지 여부
 * @param {string} subcategoryName - 실측 가이드 조회용 서브카테고리 이름
 */
export default function ProductMeasurement({
  measurements,
  isMeasurable,
  subcategoryName,
}) {
  const [isModalOpen, setModalOpen] = useState(false);

  if (
    !isMeasurable ||
    !Array.isArray(measurements) ||
    measurements.length === 0
  ) {
    return null;
  }

  return (
    <section className="Product-measurement">
      <div className="Product-measurement-header">
        <h4 className="Product-measurement-title">실측</h4>
        <button
          type="button"
          className="Product-measurement-info"
          aria-label="실측 측정 방법 안내 열기"
          onClick={() => setModalOpen(true)}
        >
          <IconInfoCircleGray />
        </button>
      </div>
      <p className="Product-measurement-disclaimer">{MEASUREMENT_DISCLAIMER}</p>
      <ProductMeasurementList measurements={measurements} />

      {isModalOpen && (
        <ProductMeasurementModal
          measurements={measurements}
          subcategoryName={subcategoryName}
          onClose={() => setModalOpen(false)}
        />
      )}
    </section>
  );
}

ProductMeasurement.propTypes = {
  measurements: PropTypes.array,
  isMeasurable: PropTypes.bool,
  subcategoryName: PropTypes.string,
};
